import React from 'react';
import { Button } from './Button';
export function HomepageShowcase() {
  return <section className="w-full py-12 md:py-24 px-4 md:px-8 bg-[#1A2331]" data-id="element-311">
      <div className="max-w-7xl mx-auto" data-id="element-312">
        <h2 className="text-3xl md:text-5xl font-bold mb-3 text-center" data-id="element-313">
          Be Ready for Every Meeting — Before the Day Even Starts
        </h2>
        <p className="text-lg md:text-xl text-[#F5F7FA] text-opacity-80 max-w-3xl mx-auto mb-12 text-center" data-id="element-314">
          AI-powered briefs that save hours, deliver insights, and make every
          meeting count.
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-315">
          {/* GIF Showcase */}
          <div className="relative" data-id="element-316">
            {/* Futuristic frame with glow effect */}
            <div className="relative rounded-xl overflow-hidden shadow-[0_0_40px_rgba(200,241,105,0.3)] border-2 border-[#C8F169] border-opacity-30" data-id="element-317">
              {/* Animated top bar with futuristic elements */}
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#3B82F6] via-[#C8F169] to-[#EC4899] z-20" data-id="element-318"></div>
              {/* Animated scan line effect */}
              <div className="absolute top-0 left-0 right-0 bottom-0 pointer-events-none z-10 overflow-hidden" data-id="element-319">
                <div className="h-px bg-[#C8F169] bg-opacity-20 w-full absolute animate-scanline" data-id="element-320"></div>
              </div>
              {/* GIF container - fixed to ensure proper containment */}
              <div className="relative bg-[#1A2331] flex items-center justify-center" data-id="element-321">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pczZuc1HsH95kaS58UjADy/prepz_landing_flow_clear.gif" alt="Prepz.io onboarding flow demonstration" className="w-full h-auto object-contain" style={{
                maxWidth: '100%',
                minHeight: '540px'
              }} data-id="element-322" />
              </div>
              {/* Screen indicator */}
              <div className="absolute top-6 left-6 z-20 bg-[#1E2A38] bg-opacity-80 backdrop-blur-sm rounded-lg px-4 py-2 text-sm font-mono text-[#C8F169] border border-[#C8F169] border-opacity-30" data-id="element-323">
                Onboarding Flow
              </div>
            </div>
            {/* Animated glowing elements */}
            <div className="absolute -top-10 -left-10 w-24 h-24 bg-[#C8F169] rounded-full filter blur-3xl opacity-10 animate-pulse" data-id="element-324"></div>
            <div className="absolute -bottom-10 -right-10 w-24 h-24 bg-[#3B82F6] rounded-full filter blur-3xl opacity-10 animate-pulse delay-1000" data-id="element-325"></div>
          </div>
          {/* Descriptive Text */}
          <div className="space-y-8" data-id="element-326">
            <div className="bg-[#1E2A38] p-6 rounded-xl border border-[#F5F7FA] border-opacity-10" data-id="element-327">
              <h3 className="text-xl md:text-2xl font-bold mb-3 text-[#C8F169]" data-id="element-328">
                Knows You. Knows Your Business.
              </h3>
              <p className="text-[#F5F7FA] text-opacity-90" data-id="element-329">
                Prepz.io learns your company, your role, and your goals —
                creating contextualized meeting briefs tailored to your world.
              </p>
            </div>
            <div className="bg-[#1E2A38] p-6 rounded-xl border border-[#F5F7FA] border-opacity-10" data-id="element-330">
              <h3 className="text-xl md:text-2xl font-bold mb-3 text-[#C8F169]" data-id="element-331">
                Deeper Insights, Zero Extra Work.
              </h3>
              <p className="text-[#F5F7FA] text-opacity-90" data-id="element-332">
                Think of it as an assistant who reads your calendar and preps
                you before you even ask.
              </p>
            </div>
            <div className="bg-[#1E2A38] p-6 rounded-xl border border-[#F5F7FA] border-opacity-10" data-id="element-333">
              <h3 className="text-xl md:text-2xl font-bold mb-3 text-[#C8F169]" data-id="element-334">
                Briefs That Meet You Where You Work.
              </h3>
              <p className="text-[#F5F7FA] text-opacity-90" data-id="element-335">
                Whether it's Slack, Teams, your CRM, email, or directly in
                Prepz.io — meeting briefs arrive automatically, without you
                lifting a finger.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-336">
          <p className="text-lg md:text-xl text-[#F5F7FA] text-opacity-80 max-w-3xl mx-auto mb-8" data-id="element-337">
            See how Prepz.io transforms your meeting preparation process with
            AI-powered insights and automated workflows—from setup to your first
            meeting brief in less than a minute.
          </p>
          <Button data-id="element-338">Get Started Free</Button>
        </div>
      </div>
    </section>;
}